// // // // InstitutionLayout.jsx
// // // import React, { useState } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import { Menu, X } from 'lucide-react';

// // // export default function InstitutionLayout({ children, title }) {
// // //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

// // //   const navItems = [
// // //     { path: '/institution-dashboard', label: 'Dashboard' },
// // //     { path: '/prestations', label: 'Prestations' },
// // //     { path: '/profile', label: 'Profil' },
// // //     { path: '/payrolls', label: 'Fiches de paie' },
// // //   ];

// // //   return (
// // //     <div className="min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50">
// // //       {/* Header */}
// // //       <header className="bg-amber-200">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
// // //           <h1 className="text-2xl font-bold text-amber-900" style={{ fontFamily: 'Playfair Display, serif' }}>
// // //             {title}
// // //           </h1>

// // //           {/* Desktop navigation */}
// // //           <div className="hidden md:flex space-x-6">
// // //             {navItems.map(item => (
// // //               <Link
// // //                 key={item.path}
// // //                 to={item.path}
// // //                 className="text-amber-900 font-semibold hover:text-amber-700 transition"
// // //               >
// // //                 {item.label}
// // //               </Link>
// // //             ))}
// // //           </div>

// // //           {/* Mobile menu button */}
// // //           <div className="md:hidden">
// // //             <button
// // //               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
// // //               className="text-amber-900 p-2 rounded-md hover:bg-amber-100 transition"
// // //             >
// // //               {mobileMenuOpen ? <X /> : <Menu />}
// // //             </button>
// // //           </div>
// // //         </div>

// // //         {/* Mobile navigation */}
// // //         {mobileMenuOpen && (
// // //           <nav className="md:hidden bg-amber-100 border-t border-amber-300">
// // //             <div className="px-4 py-2 space-y-2">
// // //               {navItems.map(item => (
// // //                 <Link
// // //                   key={item.path}
// // //                   to={item.path}
// // //                   className="block text-amber-900 font-semibold py-2 px-3 rounded hover:bg-amber-200"
// // //                   onClick={() => setMobileMenuOpen(false)}
// // //                 >
// // //                   {item.label}
// // //                 </Link>
// // //               ))}
// // //             </div>
// // //           </nav>
// // //         )}
// // //       </header>

// // //       {/* Main content */}
// // //       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
// // //         {children}
// // //       </main>
// // //     </div>
// // //   );
// // // }


// // // InstitutionLayout.jsx
// // import React, { useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { Menu, X } from 'lucide-react';

// // export default function InstitutionLayout({ children, title }) {
// //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

// //   const navItems = [
// //     { path: '/institution-dashboard', label: 'Dashboard' },
// //     // { path: '/prestations', label: 'Prestations' },
// //      { path: '/tarifications', label: 'Tarifications' },
// //     { path: '/profile', label: 'Profil' },
// //     // { path: '/instituion-profile', label: 'Profil' },
// //     { path: '/payrolls', label: 'Fiches de paie' },
// //   ];

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50">
// //       {/* Header */}
// //       <header className="bg-amber-200">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
// //           <h1 className="text-2xl font-bold text-amber-900" style={{ fontFamily: 'Playfair Display, serif' }}>
// //             {title}
// //           </h1>

// //           {/* Desktop navigation */}
// //           <div className="hidden md:flex space-x-6">
// //             {navItems.map(item => (
// //               <Link
// //                 key={item.path}
// //                 to={item.path}
// //                 className="text-amber-900 font-semibold hover:text-amber-700 transition"
// //               >
// //                 {item.label}
// //               </Link>
// //             ))}
// //           </div>

// //           {/* Mobile menu button */}
// //           <div className="md:hidden">
// //             <button
// //               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
// //               className="text-amber-900 p-2 rounded-md hover:bg-amber-100 transition"
// //             >
// //               {mobileMenuOpen ? <X /> : <Menu />}
// //             </button>
// //           </div>
// //         </div>

// //         {/* Mobile navigation */}
// //         {mobileMenuOpen && (
// //           <nav className="md:hidden bg-amber-100 border-t border-amber-300">
// //             <div className="px-4 py-2 space-y-2">
// //               {navItems.map(item => (
// //                 <Link
// //                   key={item.path}
// //                   to={item.path}
// //                   className="block text-amber-900 font-semibold py-2 px-3 rounded hover:bg-amber-200"
// //                   onClick={() => setMobileMenuOpen(false)}
// //                 >
// //                   {item.label}
// //                 </Link>
// //               ))}
// //             </div>
// //           </nav>
// //         )}
// //       </header>

// //       {/* Main content */}
// //       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
// //         {children}
// //       </main>
// //     </div>
// //   );
// // }




// // InstitutionLayout.jsx
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Menu, X } from 'lucide-react';

// export default function InstitutionLayout({ children, title }) {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   const navItems = [
//     { path: '/institution-dashboard', label: 'Dashboard' },
//     // { path: '/prestations', label: 'Prestations' },
//      { path: '/institution-dashboard/tarifications', label: 'Tarifications' },
//     { path: '/profile', label: 'Profil' },
//     // { path: '/instituion-profile', label: 'Profil' },
//     { path: '/payrolls', label: 'Facturation' },
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50">
//       {/* Header */}
//       <header className="bg-amber-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
//           <h1 className="text-2xl font-bold text-amber-900" style={{ fontFamily: 'Playfair Display, serif' }}>
//             {title}
//           </h1>

//           {/* Desktop navigation */}
//           <div className="hidden md:flex space-x-6">
//             {navItems.map(item => (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 className="text-amber-900 font-semibold hover:text-amber-700 transition"
//               >
//                 {item.label}
//               </Link>
//             ))}
//           </div>

//           {/* Mobile menu button */}
//           <div className="md:hidden">
//             <button
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//               className="text-amber-900 p-2 rounded-md hover:bg-amber-100 transition"
//             >
//               {mobileMenuOpen ? <X /> : <Menu />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile navigation */}
//         {mobileMenuOpen && (
//           <nav className="md:hidden bg-amber-100 border-t border-amber-300">
//             <div className="px-4 py-2 space-y-2">
//               {navItems.map(item => (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   className="block text-amber-900 font-semibold py-2 px-3 rounded hover:bg-amber-200"
//                   onClick={() => setMobileMenuOpen(false)}
//                 >
//                   {item.label}
//                 </Link>
//               ))}
//             </div>
//           </nav>
//         )}
//       </header>

//       {/* Main content */}
//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {children}
//       </main>
//     </div>
//   );
// }



// InstitutionLayout.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function InstitutionLayout({ children, title }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: "/institution-dashboard", label: "Dashboard" },
    { path: "/institution-dashboard/tarifications", label: "Tarifications" },
    { path: "/profile", label: "Profil" },
    { path: "/payrolls", label: "Facturation" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F4FAFA] via-[#EDF7F7] to-[#D4EBEB]">
      {/* Header */}
      <header className="bg-[#D4EBEB] border-b border-[#C1DDDD] shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
          <h1
            className="text-2xl font-bold text-[#3F7373]"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            {title}
          </h1>

          {/* Desktop navigation */}
          <div className="hidden md:flex space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-[#3F7373] font-semibold hover:text-[#4F8585] transition"
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#3F7373] p-2 rounded-md hover:bg-[#C1DDDD] transition"
              aria-label={mobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            >
              {mobileMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {/* Mobile navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden bg-[#EDF7F7] border-t border-[#C1DDDD]">
            <div className="px-4 py-2 space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="block text-[#3F7373] font-semibold py-2 px-3 rounded hover:bg-[#D4EBEB] hover:text-[#294A4A] transition"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}